import { atomWithPolling } from '@exodus/headless-ui';
import configAtom from './config.js';
import exchangeErrorAtom from './exchange-error.js';
import limitsAtom from './limits.js';
import toAssetAtom from './to-asset.js';
import { computePollInterval } from '../helpers/poll-interval.js';
import fromAssetAtom from './from-asset.js';
import fromWalletAccountAtom from './from-wallet-account.js';
import slippageAtom from './slippage.js';
const minQuoteAtom = atomWithPolling(async (get, { exodus }) => {
    get(exchangeErrorAtom);
    const fromAsset = get(fromAssetAtom);
    const limits = await get(limitsAtom);
    const config = get(configAtom);
    if (!limits)
        return { value: null, interval: config.defaultPollIntervalMs };
    const quote = await exodus.exchange.getBestQuote({
        amount: limits.ExactIn.min,
        fromAssetName: fromAsset.name,
        toAssetName: get(toAssetAtom).name,
        fromWalletAccount: get(fromWalletAccountAtom).toString(),
        slippage: get(slippageAtom),
        expiryMarginMs: config.expiryMarginMs,
    });
    const interval = computePollInterval({
        expiry: quote?.expiry,
        expiryMarginMs: config.expiryMarginMs,
        defaultPollIntervalMs: config.defaultPollIntervalMs,
        stalePollIntervalMs: config.stalePollIntervalMs,
    });
    return { value: quote, interval };
});
export default minQuoteAtom;
